import { useToast } from '@chakra-ui/react';
import { useEffect } from 'react';

import { useIsAuthVersionMismatched } from './useIsAuthVersionMismatched';

const TOAST_ID = 'stale-bundle';

type Params = {
  apiBaseUrl?: string;
  expectedVersion: string;
};

// Login-screen toast for bundles that no longer match the API's auth system. See GET /v3/auth/version.
export const useStaleBundleToast = ({ apiBaseUrl, expectedVersion }: Params) => {
  const toast = useToast();
  const isMismatched = useIsAuthVersionMismatched({ apiBaseUrl, expectedVersion });

  useEffect(() => {
    if (!isMismatched || toast.isActive(TOAST_ID)) return;

    toast({
      id: TOAST_ID,
      title: 'This page is out of date',
      description: 'Reload before signing in (Cmd/Ctrl+Shift+R).',
      status: 'warning',
      duration: 6000,
      isClosable: true,
    });
  }, [isMismatched, toast]);
};
